<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Финансы</h4>

                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <fg-input type="date"
                                                  @input="saveFilters('fi_date_start', start_date)"
                                                  label="Начальная дата"
                                                  v-model="start_date"
                                                  placeholder="">
                                        </fg-input>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <fg-input type="date"
                                                  @input="saveFilters('fi_date_end', end_date)"
                                                  label="Конечная дата"
                                                  v-model="end_date"
                                                  placeholder="">
                                        </fg-input>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="is-premium-filter" class="control-label">Категория</label>
                                        <select v-model="category_id"
                                                @change="getSubcategories()"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option v-for="c in categories" v-bind:value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="is-premium-filter" class="control-label">Подкатегория</label>
                                        <select v-model="subcategory_id"
                                                @change="saveFilters('fi_subcategory', subcategory_id)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option v-for="c in subcategories" v-bind:value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="form-group">
                                        <label for="is-premium-filter" class="control-label">Проект</label>
                                        <select v-model="project_id" multiple
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option v-for="p in projects" v-bind:value="p.id">{{ p.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Добавить запись
                                    </button>
                                </div>
                            </div>
                        </template>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': loading }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'date'">Дата</span>
                                        <span v-else-if="column === 'description'">Описание</span>
                                        <span v-else-if="column === 'category_id'">Категория</span>
                                        <span v-else-if="column === 'subcategory_id'">Подкатегория</span>
                                        <span v-else-if="column === 'project_id'">Проект</span>
                                        <span v-else-if="column === 'amount'">Сумма, $</span>
                                        <span v-else></span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <td>{{ item.date | toEasyDate }}</td>
                                    <td>{{  item.description }}</td>
                                    <td>{{  item.category_id }}</td>
                                    <td>{{  item.subcategory_id }}</td>
                                    <td>{{  item.project_id }}</td>
                                    <td>{{  item.amount | toMoneyFormat }}</td>
                                    <td>
                                        <span>
                                                <a class="text-primary" @click="edit(item['id'])">Изменить</a>
                                            </span>
                                    </td>
                                </tr>
                                <tr class="summary">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ summary | toMoneyFormat }}</td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios')
const moment = require('moment')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    data() {
        return {
            columns: ['date', 'description', 'category_id', 'subcategory_id', 'project_id', 'amount', ''],
            data: [],
            summary: 0,
            type: "",
            start_date: localStorage.getItem('fi_date_start') ? localStorage.getItem('fi_date_start') : moment().startOf('month').format('YYYY-MM-DD'),
            end_date: localStorage.getItem('fi_date_end') ? localStorage.getItem('fi_date_end') : moment().utc().format('YYYY-MM-DD'),
            category_id: localStorage.getItem('fi_category') ? localStorage.getItem('fi_category') : "",
            subcategory_id: localStorage.getItem('fi_subcategory') ? localStorage.getItem('fi_subcategory') : "",
            project_id: [],
            loading: false,
            categories: [],
            subcategories: [],
            projects: []
        }
    },
    filters: {
        toEasyDate (value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY')
            } else {
                return '';
            }
        },
        toMoneyFormat (value) {
            if (value) {
                return Intl.NumberFormat().format(value)
            } else {
                return '';
            }
        },
    },
    created: function () {
        this.get();
    },
    methods: {
        filter: function () {
            this.get();
        },
        add: function () {
            this.$router.push('/finance/create');
        },
        edit: function (id) {
            this.$router.push({
                name: 'edit-finance',
                params: {id: id}
            });
        },
        getSubcategories() {
            this.saveFilters('fi_category', this.category_id);

            if (this.category_id === "") {
                this.subcategory_id = "";
                return this.subcategories = [];
            }
            this.subcategory_id = "";
            this.subcategories = this.categories.find(c => c.id === parseInt(this.category_id)).subcategories;
        },
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            let dateStart = this.start_date === null ? '' : this.start_date;
            let dateEnd = this.end_date === null ? '' : this.end_date;

            this.loading = true;

            axios.get(
                `${this.$hostname}/admin/finance/`,
                {
                    'params': {
                        date_start: dateStart,
                        date_end: dateEnd,
                        category_id: this.category_id,
                        subcategory_id: this.subcategory_id,
                        project_id: this.project_id,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.loading = false;

                    self.data = response.data.finance;
                    self.categories = response.data.settings.categories;
                    self.projects = response.data.settings.projects;
                    self.summary = response.data.summary;

                    self.getSubcategories();
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                })
        },
        saveFilters: function(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave (to, from , next) {
        if (to.path.indexOf('finance') < 1) {
            localStorage.setItem('fi_date_start', "");
            localStorage.setItem('fi_date_end', "");
            localStorage.setItem('fi_category', "");
            localStorage.setItem('fi_subcategory', "");
            localStorage.setItem('fi_project', "");
        }
        next();
    },
}
</script>
<style scoped>

.mt10 {
    margin-top: 10px;
}

.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
th {
    padding: 12px 8px;
}
.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}
.summary td, .summary span {
    font-weight: 700 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Finance.vue